console.log('load');

$(document).ready(function(){

    if($('body').hasClass('page-template-page-testimonials')) {

        function getPhotoTransform(img) {
            if (typeof gsap !== 'undefined' && typeof gsap.getProperty === 'function') {
                return {
                    x: parseFloat(gsap.getProperty(img, 'x')) || 0,
                    y: parseFloat(gsap.getProperty(img, 'y')) || 0
                };
            }
            return { x: 0, y: 0 };
        }

        function setPhotoTransform(img, x, y) {
            if (typeof gsap !== 'undefined' && typeof gsap.set === 'function') {
                gsap.set(img, { x: x, y: y });
                return;
            }
            img.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
        }

        function clampAxis(pos, size, box) {
            if (size >= box) {
                return Math.min(0, Math.max(box - size, pos));
            }
            return 0;
        }

        function clampPhotoToCover() {
            var img = document.getElementById('bg_image');
            var output = document.getElementById('output');
            if (!img || !output) {
                return;
            }

            var outW = output.clientWidth;
            var outH = output.clientHeight;
            var imgW = img.offsetWidth;
            var imgH = img.offsetHeight;
            if (outW < 2 || outH < 2 || imgW < 2 || imgH < 2) {
                return;
            }

            var t = getPhotoTransform(img);
            var nx = clampAxis(t.x, imgW, outW);
            var ny = clampAxis(t.y, imgH, outH);
            if (nx !== t.x || ny !== t.y) {
                setPhotoTransform(img, nx, ny);
            }

            if (window.outputDrag) {
                if (typeof window.outputDrag.update === 'function') {
                    window.outputDrag.update();
                }
                if (typeof window.outputDrag.applyBounds === 'function') {
                    window.outputDrag.applyBounds(output);
                }
            }
        }

        function applyZoom(value) {
            var img = document.getElementById('bg_image');
            var output = document.getElementById('output');
            var prevW = img ? img.offsetWidth : 0;
            var prevH = img ? img.offsetHeight : 0;
            var prev = img ? getPhotoTransform(img) : { x: 0, y: 0 };

            jQuery(".image--wide").css("height", value + "%");
            jQuery(".image--wide").css("min-height", value + "%");
            jQuery(".image--high").css("width", value + "%");
            jQuery(".image--high").css("min-width", value + "%");

            if (img && output && prevW > 1 && prevH > 1) {
                var newW = img.offsetWidth;
                var newH = img.offsetHeight;
                var outW = output.clientWidth;
                var outH = output.clientHeight;
                if (newW > 1 && newH > 1 && outW > 1 && outH > 1) {
                    var nx = outW / 2 - (outW / 2 - prev.x) * (newW / prevW);
                    var ny = outH / 2 - (outH / 2 - prev.y) * (newH / prevH);
                    setPhotoTransform(img, nx, ny);
                }
            }

            clampPhotoToCover();
        }

        jQuery(document).on("input", "#rangeZ", function () {
            applyZoom(jQuery(this).val());
        });

        jQuery(document).on("change", "#rangeZ", function () {
            applyZoom(jQuery(this).val());
            if (typeof savePhotoState === 'function') {
                savePhotoState();
            }
        });

        jQuery(document).on("click", "#minus", function () {
            if(window.hasPhoto) {
                var sliderZ = jQuery("#rangeZ");
                var newStepValue = parseInt(sliderZ.val(), 10) - 5;
                sliderZ.val(newStepValue).trigger("change");
            }
        });

        jQuery(document).on("click", "#plus", function () {
            if(window.hasPhoto) {
                var sliderZ = jQuery("#rangeZ");
                var newStepValue = parseInt(sliderZ.val(), 10) + 5;
                sliderZ.val(newStepValue).trigger("change");
            }
        });

        jQuery(window).on('resize', function () {
            if (window.hasPhoto) {
                clampPhotoToCover();
            }
        });

        function normalizePhotoClassName(className) {
            var name = className ? String(className) : '';
            name = name.replace(/\bundefined\b/g, ' ').replace(/\s+/g, ' ').trim();
            if (!name) {
                name = 'bg--image image--wide';
            }
            if (name.indexOf('bg--image') === -1) {
                name = 'bg--image ' + name;
            }
            return name.replace(/\s+/g, ' ').trim();
        }

        function refreshDraggable() {
            var img = document.getElementById("bg_image");
            if (!document.getElementById("output") || !img || typeof Draggable === "undefined") {
                return;
            }

            img.setAttribute("draggable", "false");
            img.className = normalizePhotoClassName(img.className);

            if (window.outputDrag && typeof window.outputDrag.kill === "function") {
                window.outputDrag.kill();
            }

            var output = document.getElementById("output");
            var drags = Draggable.create(img, {
                type: "x,y",
                bounds: output,
                edgeResistance: 1,
                inertia: false,
                allowContextMenu: true,
                onDragEnd: clampPhotoToCover
            });

            window.outputDrag = drags && drags[0] ? drags[0] : null;
            if (window.outputDrag && !window.hasPhoto) {
                window.outputDrag.disable();
            }
            clampPhotoToCover();
        }

        refreshDraggable();

        function getTestimonialFormId() {
            var pageLang = document.documentElement.lang.slice(0, 2);
            if (pageLang === 'fr') {
                return 3;
            }
            if (pageLang === 'it') {
                return 4;
            }
            return 2;
        }

        function getSelectedOptionText($select) {
            var el = $select && $select[0];
            if (!el || el.selectedIndex < 0) {
                return '';
            }
            var opt = el.options[el.selectedIndex];
            if (!opt) {
                return '';
            }
            // Android often returns an empty option.label when no label attribute is set.
            return String(opt.text || opt.label || jQuery(opt).text() || '').trim();
        }

        function getOwnQuotePrefix(pageLang) {
            if (pageLang === 'fr') {
                return 'À l’Aide et soins à domicile, je reste cool, même ';
            }
            if (pageLang === 'it') {
                return 'Come collaboratore/trice dello Spitex rimango cool, anche quando ';
            }
            return 'Als Spitex-Mitarbeiter:in bleibe ich cool, auch wenn ';
        }

        function getStatementPreviewValues() {
            var formId = getTestimonialFormId();
            var $firstName = jQuery('#input_' + formId + '_2');
            var $lastName = jQuery('#input_' + formId + '_3');
            var $funktion = jQuery('#input_' + formId + '_8');
            var $statementSelect = jQuery('#input_' + formId + '_1');
            var $statementText = jQuery('#input_' + formId + '_14');
            var hasFields = !!(
                $firstName.length ||
                $lastName.length ||
                $funktion.length ||
                $statementSelect.length ||
                $statementText.length
            );

            if (!hasFields) {
                return { hasFields: false, statement: '', userName: '' };
            }

            var funktionVal = ($funktion.val() || '').trim();
            var userName = (($firstName.val() || '') + ' ' + ($lastName.val() || '')).trim();
            if (funktionVal) {
                userName = (userName ? userName + ' - ' : '') + funktionVal;
            }

            var statementSelectVal = $statementSelect.val() || '';
            var statement = '';
            if (statementSelectVal === 'own') {
                var pageLang = document.documentElement.lang.slice(0, 2);
                var ownText = $statementText.val() || '';
                var prefix = getOwnQuotePrefix(pageLang);
                if (ownText.indexOf(prefix) === 0) {
                    statement = ownText;
                } else {
                    statement = prefix + ownText;
                }
            } else if (statementSelectVal) {
                statement = getSelectedOptionText($statementSelect);
            }

            return { hasFields: true, statement: statement, userName: userName };
        }

        function applyStatementToPreview(options) {
            options = options || {};
            var force = !!options.force;
            var values = getStatementPreviewValues();
            var $statementDiv = jQuery('#statementText');
            var $userNameDiv = jQuery('#user_name');

            if (values.hasFields) {
                if ($statementDiv.length && (force || values.statement)) {
                    $statementDiv.text(values.statement);
                }
                if ($userNameDiv.length && (force || values.userName)) {
                    $userNameDiv.text(values.userName);
                }
                if (!window.testimonialPhotoState) {
                    window.testimonialPhotoState = {};
                }
                if (force || values.statement) {
                    window.testimonialPhotoState.statement = values.statement;
                }
                if (force || values.userName) {
                    window.testimonialPhotoState.userName = values.userName;
                }
                return values.hasFields;
            }

            var state = window.testimonialPhotoState;
            if (state) {
                if ($statementDiv.length && state.statement) {
                    $statementDiv.text(state.statement);
                }
                if ($userNameDiv.length && state.userName) {
                    $userNameDiv.text(state.userName);
                }
            }
            return false;
        }

        function isFinalTestimonialSubmit(data, formId) {
            if (window.gform && window.gform.submission && window.gform.submission.SUBMISSION_TYPE_SUBMIT) {
                return data.submissionType === window.gform.submission.SUBMISSION_TYPE_SUBMIT;
            }
            var target = document.getElementById('gform_target_page_number_' + formId);
            return !target || String(target.value) === '0';
        }

        function showPhotoError() {
            var $error = jQuery('.error--photo');
            $error.fadeIn();
            if ($error.length && $error.offset()) {
                jQuery('html, body').animate(
                    {
                        scrollTop: $error.offset().top - 150
                    },
                    'slow'
                );
            }
        }

        function isPrivacyChecked(formId) {
            var checkbox = document.querySelector('#choice_' + formId + '_12_1, #gform_' + formId + ' input[name="input_12.1"]');
            return !checkbox || checkbox.checked;
        }

        function waitForOutputImages(outputEl) {
            var images = outputEl.querySelectorAll('img');
            var waits = [];
            for (var i = 0; i < images.length; i++) {
                (function (img) {
                    if (img.complete && img.naturalWidth) {
                        return;
                    }
                    waits.push(new Promise(function (resolve) {
                        var done = function () {
                            img.removeEventListener('load', done);
                            img.removeEventListener('error', done);
                            resolve();
                        };
                        img.addEventListener('load', done);
                        img.addEventListener('error', done);
                        setTimeout(done, 4000);
                    }));
                })(images[i]);
            }
            return waits.length ? Promise.all(waits) : Promise.resolve();
        }

        function waitForFonts() {
            if (document.fonts && document.fonts.ready) {
                return document.fonts.ready.catch(function () {});
            }
            return Promise.resolve();
        }

        function rectInOutput(el, outputEl) {
            var outputRect = outputEl.getBoundingClientRect();
            var rect = el.getBoundingClientRect();
            return {
                x: rect.left - outputRect.left,
                y: rect.top - outputRect.top,
                w: rect.width,
                h: rect.height
            };
        }

        function wrapCanvasText(ctx, text, maxWidth) {
            var words = String(text || '').split(/\s+/).filter(Boolean);
            var lines = [];
            var line = '';

            function pushLongWord(word) {
                var rest = word;
                while (rest.length && ctx.measureText(rest).width > maxWidth) {
                    var cut = rest.length - 1;
                    while (cut > 1 && ctx.measureText(rest.slice(0, cut)).width > maxWidth) {
                        cut--;
                    }
                    lines.push(rest.slice(0, cut));
                    rest = rest.slice(cut);
                }
                return rest;
            }

            for (var i = 0; i < words.length; i++) {
                var word = words[i];
                var next = line ? line + ' ' + word : word;
                if (line && ctx.measureText(next).width > maxWidth) {
                    lines.push(line);
                    line = pushLongWord(word);
                } else if (!line && ctx.measureText(word).width > maxWidth) {
                    line = pushLongWord(word);
                } else {
                    line = next;
                }
            }
            if (line) {
                lines.push(line);
            }
            return lines;
        }

        function drawWrappedDomText(ctx, el, outputEl, scale) {
            if (!el || !String(el.textContent || '').trim()) {
                return;
            }
            var style = window.getComputedStyle(el);
            var fontSize = parseFloat(style.fontSize) || 16;
            var lineHeight = parseFloat(style.lineHeight);
            if (!lineHeight) {
                lineHeight = fontSize * 1.3;
            }
            var font = (style.fontWeight || '600') + ' ' + (fontSize * scale) + 'px ' + (style.fontFamily || 'Open Sans, sans-serif');
            ctx.fillStyle = style.color || '#ffffff';
            ctx.font = font;
            ctx.textBaseline = 'top';
            ctx.textAlign = 'left';
            var rect = rectInOutput(el, outputEl);
            var lines = wrapCanvasText(ctx, el.textContent, Math.max(1, rect.w * scale));
            var y = rect.y * scale;
            var lh = lineHeight * scale;
            for (var i = 0; i < lines.length; i++) {
                ctx.fillText(lines[i], rect.x * scale, y);
                y += lh;
            }
        }

        function loadSvgAsImage(svgEl) {
            return new Promise(function (resolve) {
                if (!svgEl) {
                    resolve(null);
                    return;
                }
                var clone = svgEl.cloneNode(true);
                if (!clone.getAttribute('xmlns')) {
                    clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
                }
                var box = svgEl.getBoundingClientRect();
                if (!clone.getAttribute('width') && box.width) {
                    clone.setAttribute('width', String(box.width));
                }
                if (!clone.getAttribute('height') && box.height) {
                    clone.setAttribute('height', String(box.height));
                }
                var xml = new XMLSerializer().serializeToString(clone);
                var image = new Image();
                image.onload = function () {
                    resolve(image);
                };
                image.onerror = function () {
                    resolve(null);
                };
                image.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(xml);
            });
        }

        function captureTestimonialOutput(outputEl) {
            if (outputEl.offsetWidth < 2 || outputEl.offsetHeight < 2) {
                setupTestimonialUI();
                outputEl = document.getElementById('output');
            }
            if (!outputEl) {
                return Promise.reject(new Error('testimonial output missing'));
            }

            applyStatementToPreview({ force: true });
            clampPhotoToCover();

            var width = outputEl.clientWidth || outputEl.offsetWidth;
            var height = outputEl.clientHeight || outputEl.offsetHeight;
            if (width < 2 || height < 2) {
                return Promise.reject(new Error('testimonial output not visible'));
            }

            // Match the previous html2canvas output: 26rem × scale 3 = 1248px.
            var targetSize = 1248;
            var scale = targetSize / Math.max(width, 1);
            var photo = document.getElementById('bg_image');
            var badge = outputEl.querySelector('.badge--image');
            var logoSvg = outputEl.querySelector('#fixedtext svg');
            var statementWrap = outputEl.querySelector('.statement--wrap');
            var statementText = document.getElementById('statementText');
            var userName = document.getElementById('user_name');

            return waitForOutputImages(outputEl).then(function () {
                return waitForFonts();
            }).then(function () {
                return loadSvgAsImage(logoSvg);
            }).then(function (logoImage) {
                clampPhotoToCover();

                var canvas = document.createElement('canvas');
                canvas.width = targetSize;
                canvas.height = targetSize;
                var ctx = canvas.getContext('2d');
                if (!ctx) {
                    throw new Error('canvas context missing');
                }

                ctx.imageSmoothingEnabled = true;
                if (ctx.imageSmoothingQuality) {
                    ctx.imageSmoothingQuality = 'high';
                }
                ctx.fillStyle = '#ffffff';
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                ctx.save();
                ctx.beginPath();
                ctx.rect(0, 0, canvas.width, canvas.height);
                ctx.clip();

                if (photo && photo.naturalWidth) {
                    var photoRect = rectInOutput(photo, outputEl);
                    ctx.drawImage(
                        photo,
                        photoRect.x * scale,
                        photoRect.y * scale,
                        photoRect.w * scale,
                        photoRect.h * scale
                    );
                }

                if (statementWrap) {
                    var box = rectInOutput(statementWrap, outputEl);
                    var wrapStyle = window.getComputedStyle(statementWrap);
                    ctx.fillStyle = wrapStyle.backgroundColor || '#015FAD';
                    ctx.fillRect(box.x * scale, box.y * scale, box.w * scale, box.h * scale);
                    drawWrappedDomText(ctx, statementText, outputEl, scale);
                    drawWrappedDomText(ctx, userName, outputEl, scale);
                }

                if (badge && badge.naturalWidth) {
                    var badgeRect = rectInOutput(badge, outputEl);
                    ctx.drawImage(badge, badgeRect.x * scale, badgeRect.y * scale, badgeRect.w * scale, badgeRect.h * scale);
                }

                if (logoImage) {
                    var logoWrap = document.getElementById('fixedtext');
                    var logoRect = logoWrap ? rectInOutput(logoWrap, outputEl) : rectInOutput(logoSvg, outputEl);
                    ctx.drawImage(logoImage, logoRect.x * scale, logoRect.y * scale, logoRect.w * scale, logoRect.h * scale);
                }

                ctx.restore();
                return canvas;
            });
        }

        function canvasToJpegBlob(canvas, quality) {
            return new Promise(function (resolve, reject) {
                var done = function (blob) {
                    if (blob && blob.size) {
                        resolve(blob);
                        return;
                    }
                    reject(new Error('jpeg blob empty'));
                };
                if (typeof canvas.toBlob === 'function') {
                    canvas.toBlob(done, 'image/jpeg', quality);
                    return;
                }
                try {
                    var url = canvas.toDataURL('image/jpeg', quality);
                    var bin = atob((url.split(',')[1] || ''));
                    var arr = new Uint8Array(bin.length);
                    for (var i = 0; i < bin.length; i++) {
                        arr[i] = bin.charCodeAt(i);
                    }
                    done(new Blob([arr], { type: 'image/jpeg' }));
                } catch (err) {
                    reject(err);
                }
            });
        }

        function getCompositeFileInput(form) {
            var input = form.querySelector('#testimonial_composite_file');
            if (input) {
                return input;
            }
            input = document.createElement('input');
            input.type = 'file';
            input.name = 'testimonial_composite';
            input.id = 'testimonial_composite_file';
            input.accept = 'image/jpeg';
            input.hidden = true;
            form.appendChild(input);
            return input;
        }

        function attachCompositeFile(form, file) {
            if (typeof DataTransfer === 'undefined') {
                return false;
            }
            var input = getCompositeFileInput(form);
            var dt = new DataTransfer();
            dt.items.add(file);
            input.files = dt.files;
            return !!(input.files && input.files.length === 1);
        }

        function prepareTestimonialSubmission(data) {
            var formId = getTestimonialFormId();
            var submittedId = 0;
            if (data.form) {
                submittedId = parseInt(
                    (data.form.dataset && data.form.dataset.formid) ||
                    data.form.getAttribute('data-formid') ||
                    String(data.form.id || '').replace('gform_', ''),
                    10
                );
            }
            if (submittedId !== formId || data.abort) {
                return data;
            }

            applyStatementToPreview({ force: true });
            savePhotoState();

            if (!isFinalTestimonialSubmit(data, formId)) {
                return data;
            }

            if (!window.hasPhoto) {
                data.abort = true;
                showPhotoError();
                return data;
            }

            var outputEl = document.getElementById('output');
            var imageInput = document.getElementById('input_' + formId + '_7');
            if (!outputEl || !imageInput) {
                return data;
            }

            jQuery('.error--photo').fadeOut();
            savePhotoState();

            if (!isPrivacyChecked(formId)) {
                return data;
            }

            return captureTestimonialOutput(outputEl).then(function (canvas) {
                return canvasToJpegBlob(canvas, 0.85).then(function (blob) {
                    var file = new File([blob], 'testimony.jpg', { type: 'image/jpeg' });
                    // A data-URL in the hidden text field is cut at 512 KiB and
                    // saves as a truncated JPEG (grey bar). Send a real file instead.
                    if (attachCompositeFile(data.form, file)) {
                        imageInput.value = '';
                    } else {
                        imageInput.value = canvas.toDataURL('image/jpeg', 0.85);
                    }
                    savePhotoState();
                    return data;
                });
            }).catch(function (err) {
                console.error(err);
                data.abort = true;
                return data;
            });
        }

        function restorePhotoAfterAjax(data) {
            window.testimonialDeferRestore = false;
            setTimeout(function () {
                setupTestimonialUI();
            }, 0);
            return data;
        }

        function bindTestimonialPreSubmit() {
            if (window.testimonialPreSubmitBound) {
                return true;
            }
            if (!window.gform || !window.gform.utils || typeof window.gform.utils.addAsyncFilter !== 'function') {
                return false;
            }

            window.testimonialPreSubmitBound = true;
            window.gform.utils.addAsyncFilter('gform/submission/pre_submission', function (data) {
                return prepareTestimonialSubmission(data);
            });
            if (typeof window.gform.utils.addFilter === 'function') {
                window.gform.utils.addFilter('gform/ajax/post_ajax_submission', restorePhotoAfterAjax);
                window.gform.utils.addFilter('gform/ajax/pre_display_error', restorePhotoAfterAjax);
            }

            document.addEventListener('gform/submission/submission_aborted', function (event) {
                var form = event.detail && event.detail.form;
                var abortedId = form && form.dataset ? parseInt(form.dataset.formid, 10) : 0;
                if (abortedId === getTestimonialFormId()) {
                    setupTestimonialUI();
                }
            });
            document.addEventListener('gform/post_render', function (event) {
                var detail = event.detail || {};
                var renderedId = parseInt(detail.formId || (detail.data && detail.data.formId), 10);
                if (renderedId === getTestimonialFormId()) {
                    setupTestimonialUI();
                }
            });

            bindPhotoHolderObserver();

            return true;
        }

        function initTestimonialSubmission() {
            if (bindTestimonialPreSubmit()) {
                return;
            }
            if (window.gform && typeof window.gform.initializeOnLoaded === 'function' && !window.testimonialPreSubmitWaiting) {
                window.testimonialPreSubmitWaiting = true;
                window.gform.initializeOnLoaded(function () {
                    bindTestimonialPreSubmit();
                });
                return;
            }
            window.testimonialPreSubmitAttempts = (window.testimonialPreSubmitAttempts || 0) + 1;
            if (window.testimonialPreSubmitAttempts < 20) {
                setTimeout(initTestimonialSubmission, 250);
            }
        }

        function getPhotoStash() {
            var $stash = jQuery('#testimonial-photo-stash');
            if (!$stash.length) {
                $stash = jQuery('<div id="testimonial-photo-stash" hidden></div>');
                jQuery('.section--testimonials .container').append($stash);
            }
            return $stash;
        }

        function cachePhotoNodes() {
            var $ctrl = jQuery('#photocontainerControls');
            if ($ctrl.length) {
                window.photoctrl = $ctrl;
            }
            var $cont = jQuery('#photocontainer');
            if ($cont.length) {
                window.photocont = $cont;
            }
        }

        function bindPhotoHolderObserver() {
            if (window.testimonialHolderObserverBound) {
                return;
            }
            var container = document.querySelector('.section--testimonials .container');
            if (!container || typeof MutationObserver === 'undefined') {
                return;
            }
            window.testimonialHolderObserverBound = true;
            var observer = new MutationObserver(function () {
                if (
                    !window.testimonialDeferRestore &&
                    isPhotoStashed() &&
                    document.getElementById('camera_holder')
                ) {
                    setupTestimonialUI();
                }
            });
            observer.observe(container, { childList: true, subtree: true });
        }

        function savePhotoState() {
            var img = document.getElementById('bg_image');
            var range = document.getElementById('rangeZ');
            var prev = window.testimonialPhotoState || {};
            var statement = jQuery('#statementText').text() || prev.statement || '';
            var userName = jQuery('#user_name').text() || prev.userName || '';

            if (!img) {
                window.testimonialPhotoState = jQuery.extend({}, prev, {
                    statement: statement,
                    userName: userName
                });
                return;
            }

            window.testimonialPhotoState = {
                hasPhoto: !!window.hasPhoto,
                src: img.getAttribute('src') || prev.src || '',
                className: normalizePhotoClassName(img.className || prev.className),
                style: img.getAttribute('style') || prev.style || '',
                zoom: range ? range.value : (prev.zoom || '100'),
                statement: statement,
                userName: userName
            };
        }

        function restorePhotoState() {
            var state = window.testimonialPhotoState;
            var img = document.getElementById('bg_image');
            var range = document.getElementById('rangeZ');
            if (!state) {
                return;
            }

            if (img && state.src) {
                img.src = state.src;
                if (state.className) {
                    img.className = normalizePhotoClassName(state.className);
                } else {
                    img.className = normalizePhotoClassName(img.className);
                }
                if (typeof state.style === 'string') {
                    img.setAttribute('style', state.style);
                }
                img.setAttribute('draggable', 'false');
                if (range && state.zoom) {
                    range.value = state.zoom;
                    applyZoom(state.zoom);
                }
            } else if (img) {
                img.className = normalizePhotoClassName(img.className);
                img.setAttribute('draggable', 'false');
            }

            if (typeof state.hasPhoto === 'boolean') {
                window.hasPhoto = state.hasPhoto;
            }
            if (state.statement) {
                jQuery('#statementText').text(state.statement);
            }
            if (state.userName) {
                jQuery('#user_name').text(state.userName);
            }
            clampPhotoToCover();
        }

        function isPhotoStashed() {
            var cont = document.getElementById('photocontainer');
            return !!(cont && cont.parentElement && cont.parentElement.id === 'testimonial-photo-stash');
        }

        function stashPhotoUI() {
            window.testimonialDeferRestore = true;
            cachePhotoNodes();
            window.testimonialHolderEl = document.getElementById('camera_holder');
            var $stash = getPhotoStash();
            if (window.photocont && window.photocont.length) {
                $stash.append(window.photocont);
            }
            if (window.photoctrl && window.photoctrl.length) {
                $stash.append(window.photoctrl);
            }
            clearTimeout(window.testimonialDeferRestoreTimer);
            window.testimonialDeferRestoreTimer = setTimeout(function () {
                window.testimonialDeferRestore = false;
                restorePreviewIfNeeded();
            }, 800);
        }

        function setupTestimonialUI() {
            if (window.testimonialSetupRunning) {
                return;
            }
            window.testimonialSetupRunning = true;
            try {
            var formId = getTestimonialFormId();
            var $holder = jQuery('#camera_holder');
            var pageLang = document.documentElement.lang.slice(0, 2);
            var $fileField = pageLang == 'fr' ? jQuery('#field_3_4') : pageLang == 'it' ? jQuery('#field_4_4') : jQuery('#field_2_4');
            var preservePhoto = !!window.hasPhoto || !!(window.testimonialPhotoState && window.testimonialPhotoState.src);

            cachePhotoNodes();

            if ($fileField.length && window.photoctrl && window.photoctrl.length) {
                window.photoctrl.insertAfter($fileField);
                window.photoctrl.css('display', 'block');
            }

            if ($holder.length && window.photocont && window.photocont.length) {
                window.photocont.appendTo($holder);
                window.photocont.css('display', 'block');
                window.testimonialHolderEl = $holder.get(0);
            } else if (!$holder.length) {
                stashPhotoUI();
            }

            if (window.standardImage && jQuery('#photocontainerControls').length && !jQuery('#btnUseStandard').length) {
                jQuery('#photocontainerControls').after('<div class="col-span-full"><button id="btnUseStandard" class="button--primary">' + window.standardImageBtn + '</button></div>');
            }

            if (typeof startup === 'function') {
                startup({ preservePhoto: preservePhoto });
            }

            restorePhotoState();
            applyStatementToPreview({ force: true });
            refreshDraggable();
            initTestimonialSubmission();
            bindSwiperPreviewRestore();
            } finally {
                window.testimonialSetupRunning = false;
            }
        }

        window.initTestimonial = setupTestimonialUI;
        window.saveTestimonialPhotoState = savePhotoState;
        window.refreshTestimonialDraggable = refreshDraggable;
        window.clampTestimonialPhoto = clampPhotoToCover;
        window.captureTestimonialOutput = captureTestimonialOutput;

        jQuery(document).on('submit', '#gform_2, #gform_3, #gform_4', function () {
            applyStatementToPreview({ force: true });
            savePhotoState();
            stashPhotoUI();
        });

        jQuery(document).on('gform_post_render gform_page_loaded', function (event, formId) {
            if (parseInt(formId, 10) === getTestimonialFormId()) {
                setupTestimonialUI();
            }
        });

        initTestimonialSubmission();
        setTimeout(setupTestimonialUI, 500);

        function isTestimonialNavControl(el) {
            if (!el || !el.closest) {
                return false;
            }
            return !!el.closest(
                '.gform_next_button, .gform_previous_button, [data-submission-type="next"], [data-submission-type="previous"]'
            );
        }

        function persistTestimonialPreview() {
            applyStatementToPreview({ force: true });
            savePhotoState();
        }

        function restorePreviewIfNeeded() {
            if (isPhotoStashed() && document.getElementById('camera_holder')) {
                setupTestimonialUI();
                return;
            }
            persistTestimonialPreview();
        }

        function bindSwiperPreviewRestore() {
            var form = document.getElementById('gform_' + getTestimonialFormId());
            if (!form || form.dataset.testimonialSwiperBound === '1') {
                return;
            }
            var wrap = form.classList.contains('swiper') ? form : form.querySelector('.swiper');
            var swiper = form.swiper || (wrap && wrap.swiper);
            if (!swiper || typeof swiper.on !== 'function') {
                return;
            }
            form.dataset.testimonialSwiperBound = '1';
            swiper.on('slideChangeTransitionEnd', function () {
                restorePreviewIfNeeded();
            });
            swiper.on('slideChange', function () {
                restorePreviewIfNeeded();
            });
        }

        // Capture phase runs before Gravity Forms 2.9 handleButtonClick(preventDefault).
        // On Android that preventDefault often swallows the bubbling click we used before.
        document.addEventListener('pointerdown', function (event) {
            if (isTestimonialNavControl(event.target)) {
                persistTestimonialPreview();
            }
        }, true);
        document.addEventListener('click', function (event) {
            if (isTestimonialNavControl(event.target)) {
                persistTestimonialPreview();
                setTimeout(restorePreviewIfNeeded, 0);
                setTimeout(restorePreviewIfNeeded, 400);
            }
        }, true);

        jQuery(document).on(
            'input change',
            '#input_2_1, #input_2_2, #input_2_3, #input_2_8, #input_2_14, #input_3_1, #input_3_2, #input_3_3, #input_3_8, #input_3_14, #input_4_1, #input_4_2, #input_4_3, #input_4_8, #input_4_14',
            function () {
                applyStatementToPreview({ force: true });
                savePhotoState();
            }
        );
        

        // if(window.standardImage) {
        //     jQuery(document).on('click','#btnUseStandard', function(e) {
        //         e.preventDefault();
        //         var bg_image = document.getElementById('bg_image');
        //         bg_image.src = window.standardImage;
        //         var image = new Image();
        //         image.src = window.standardImage;
        //         image.onload = function() {
        //             var imgWidth = image.width;
        //             var imgHeight = image.height;
        //             if (imgWidth > imgHeight) {
        //                 rangeZ.value = 100;
        //                 bg_image.style.height = "100%";
        //                 bg_image.style.minHeight = "100%";
        //                 bg_image.style.width = "auto";
        //                 bg_image.style.minWidth = "auto";
        //                 bg_image.classList.add("image--wide");
        //                 bg_image.classList.remove("image--high");
        //                 // console.log("test img wide");
        //             } else {
        //                 rangeZ.value = 100;
        //                 bg_image.style.width = "100%";
        //                 bg_image.style.minWidth = "100%";
        //                 bg_image.style.height = "auto";
        //                 bg_image.style.minHeight = "auto";
        //                 bg_image.classList.add("image--high");
        //                 bg_image.classList.remove("image--wide");
        //             }
        //         }
        //         window.hasPhoto = true;
        //         if(window.outputDrag) {
        //             window.outputDrag.enable();
        //         }
        //         return false;
        //     });
        // }
    }
});